import { createAction } from 'redux-actions';

export const changeSearchBoxToggle = createAction('CHANGE_SEARCH_TOGGLE');
export const changeFiltersToggle = createAction('CHANGE_FILTERS_TOGGLE');
export const changeUniversalDropdownToggle = createAction('CHANGE_UNIVERSAL_TOGGLE');
export const closeSearchToggles = createAction('CLOSE_SEARCH_TOGGLES');
